import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root"
})
export class EmpresaService {
  public url: string;

  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getEmpresas(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "empresas", { headers: headers });
  }

  getEmpresasByGrupo(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "empresasByUser", { headers: headers });
  }

  getEmpresa(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "empresas/" + id, { headers: headers });
  }

  getEmpresasActivas(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "getEmpresasActivas", {
      headers: headers
    });
  }

  updateEmpresa(token, id, empresa): Observable<any> {
    let json = JSON.stringify(empresa);
    //let params = 'json='+json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "empresas/" + id, json, {
      headers: headers
    });
  }

  updateEmpresaFromAdmin(token, id, empresa): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(empresa));
    let params = 'json=' + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "actualizar_empresa/" + id, params, {
      headers: headers
    });
  }

  updateCredentials(token, representante_id, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = 'json=' + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "changeCredentialsByAdmin/" + representante_id, params, {
      headers: headers
    });
  }

  attachEmpresa(token, image: any, empresa, licencia): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(empresa));
    //let params = 'json='+json;

    let headers = new HttpHeaders().set("Authorization", token);
    // Url del back
    return this._http.post(
      this.url + "attachEmpresa/" + empresa + "/" + licencia,
      image,
      { headers: headers }
    );
  }

  findEmpresa(token, empresa): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(empresa));
    let params = 'json=' + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "findEmpresas", params, { headers: headers });
  }

  assignEmpresa(token, empresa): Observable<any> {
    let json = JSON.stringify(empresa);
    let headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Authorization", token);
    return this._http.post(this.url + "assignEmpresa", json, {
      headers: headers
    });
  }

  addEmpresa(token, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = 'json=' + json;
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.post(this.url + "addEmpresa", params, {
      headers: headers
    });
  }

  vincularEmpresa(token): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "vincularEmpresas", { headers: headers });
  }

  getEmptyHabitaciones(token): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "getEmptyHabitaciones", { headers: headers });
  }

  getAllEmpresas(token): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "getEmpresas", { headers: headers });
  }

  getEmpresasByGroup(token): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "getEmpresasByGroup", { headers: headers });
  }

  unlinkEmpresa(token, licencia_funcionamiento): Observable<any> {
    let headers = new HttpHeaders().set("Authorization", token);
    return this._http.get(this.url + "desvincularEmpresa/" + licencia_funcionamiento, { headers: headers });
  }
}
